export const api = {
  baseUrl: "https://api.bvb.cybertech.com.vn/api/v1",
};
